import Icon from 'veui/components/Icon'
import { IconAsterisk } from 'dls-icons-vue'

Icon.register('asterisk', IconAsterisk)
